// VX-3 레인 C — 상세 이미지 클라이언트 조각들이 같이 쓰는 «브라우저 쪽» 작은 도구(이벤트 이름 · 신고 저장 · 세션 상한).
// 판정은 전부 lib/apt/detail-vx3.ts(순수)에 있다. 여기는 window·storage 접근만 — 전부 try/catch(막혀 있어도 화면은 그대로 돈다).

import {
  IMAGE_REPORT_ENDPOINT, IMAGE_REPORT_STORE_KEY, HERO_TIME_TRACK_CAP,
  addReported, canTrackHeroTime, parseReported,
} from '@/lib/apt/detail-vx3';

/** 히어로 그림 탭 → 갤러리 블록의 ShotViewer 가 받아 라이트박스를 연다(두 클라이언트 섬을 잇는 유일한 선). */
export const SHOTS_OPEN_EVENT = 'kd:shots-open';
export interface ShotsOpenDetail { shot?: string | null; via?: string }

export function requestShotsOpen(detail: ShotsOpenDetail): void {
  try { window.dispatchEvent(new CustomEvent<ShotsOpenDetail>(SHOTS_OPEN_EVENT, { detail })); } catch { /* 구형 브라우저 — 열리지 않을 뿐 */ }
}

export function readReported(): string[] {
  try { return parseReported(window.localStorage.getItem(IMAGE_REPORT_STORE_KEY)); } catch { return []; }
}

/** 키를 저장하고 새 목록을 돌려준다(저장이 막혀 있어도 목록은 돌려준다 — 이 화면에서는 다시 못 누른다). */
export function storeReported(list: readonly string[], key: string): string[] {
  const next = addReported(list, key);
  try { window.localStorage.setItem(IMAGE_REPORT_STORE_KEY, JSON.stringify(next)); } catch { /* 사생활 보호 모드 등 */ }
  return next;
}

/** 신고 전송 — 실패는 조용히(응답을 기다리지 않는다). */
export function sendImageReport(siteId: string, shot: string): void {
  try {
    void fetch(IMAGE_REPORT_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ siteId, shot }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* 조용히 */ }
}

const HERO_TIME_COUNT_KEY = 'kd_hero_time_n';
let heroTimeMemory = 0;

/** hero_time_toggle 을 지금 보내도 되는가 — 세션당 상한. 된다면 횟수를 올린다. */
export function takeHeroTimeTrackSlot(): boolean {
  let n = heroTimeMemory;
  try { n = Math.max(n, parseInt(window.sessionStorage.getItem(HERO_TIME_COUNT_KEY) || '0', 10) || 0); } catch { /* 메모리 값만 */ }
  if (!canTrackHeroTime(n, HERO_TIME_TRACK_CAP)) return false;
  heroTimeMemory = n + 1;
  try { window.sessionStorage.setItem(HERO_TIME_COUNT_KEY, String(n + 1)); } catch { /* 메모리 값만 */ }
  return true;
}

export function prefersReducedMotion(): boolean {
  try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch { return false; }
}
